import { render, staticRenderFns } from "./work_openHook_account.vue?vue&type=template&id=acbcd94e"
import script from "./work_openHook_account.vue?vue&type=script&lang=js"
export * from "./work_openHook_account.vue?vue&type=script&lang=js"
import style0 from "./work_openHook_account.vue?vue&type=style&index=0&id=acbcd94e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports